import React from 'react';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Select, Input, DatePicker,Row,Col } from 'antd';
const FormItem = Form.Item;
import request from '../utils/request';

class HeadAddFrom extends React.Component {
    constructor(props) {
        super(props);
        this.state = { visible: false, record: {} };
        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    handleClick(e) {
        this.setState(Object.assign(this.state, { visible: true }, { record: {} }))
    }
    handleCancel(e) { this.setState({ visible: false }) }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                Object.keys(values).forEach((key, index) => {
                    this.state.record[key] = values[key];
                    this.setState(this.state);
                });
                let record = this.state.record;
                const { url, handleRefresh } = this.props;
                (async (url) => {
                    try {
                        let response = await request(url, 'post', record);
                        message.success('添加成功');
                        this.setState({ visible: false });
                        handleRefresh();
                    } catch (e) {
                        console.log(e);
                        message.error('添加失败');
                    }
                })(url)
            }
        });
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    render() {
        let { metadata } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <span>
                <Button type="primary" className="ant-btn ant-btn-primary ant-btn-lg" onClick={this.handleClick} >添加</Button>
                <Modal
                    title="添加"
                    footer={null}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                >
                    <Form onSubmit={this.handleSubmit}>
                        {metadata.map((meta, index) => {
                            switch (meta.type) {
                                case 'Input':
                                    return <FormItem label={meta.label}  >
                                        {getFieldDecorator(meta.field, {
                                            initialValue : meta.initialValue,
                                            rules: [{ required: meta.isRequired ? meta.isRequired : false, message: meta.label + '是必须的!' }],
                                        })(<Input
                                            key={index}
                                            addonBefore={meta.addonBefore}
                                            placeholder={meta.placeholder} />)}
                                    </FormItem>;
                                case 'Select': return <FormItem label={meta.label}  >
                                    {getFieldDecorator(meta.field, {
                                        initialValue : meta.initialValue,
                                        rules: [{ required: meta.isRequired ? meta.isRequired : false, message: meta.label + '是必须的!' }],
                                    })(
                                        <Select placeholder={meta.placeholder} >
                                            {meta.options.map((item, index) => {
                                                return <Option key={index} value={
                                                    item.split("|").length > 1 ? item.split("|")[1] : item
                                                }>{
                                                    item.split("|").length > 1 ? item.split("|")[0] : item
                                                }</Option>
                                            })}
                                        </Select>)}
                                </FormItem>;
                                case 'DatePicker':
                                    return <FormItem label={meta.label}>
                                        {getFieldDecorator(meta.field, {
                                            rules: [{ type: 'object', required: meta.isRequired ? meta.isRequired : false, message: '请选择时间' }]
                                        })(
                                            <DatePicker />)}
                                    </FormItem>;
                            }
                        })}
                        <Button type="primary" style={{marginRight:'10px'}} htmlType="submit">Submit</Button>
                        <Button type="primary" onClick={this.handleReset}>Clear</Button>
                    </Form>
                </Modal>
            </span >
        );
    }
}

export default Form.create()(HeadAddFrom);



// WEBPACK FOOTER //
// ./utils/head-add.js